// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { Module } from 'vuex'
import type {OrderItem} from '../../../types/order-item'

export type OrderItemsState = {
  orderItemsForCurrentFilter: OrderItem[],
  totalNoOrderItemsForCurrentFilter: number,
  orderItemsCurrentPageNumber: number,
  orderItemsPageSize: number,
  orderItemsOrderBy: ?string,
  orderItemsOrderDirection: ?string,
}
const initialState = (): OrderItemsState => {
  return {
    orderItemsForCurrentFilter: [],
    totalNoOrderItemsForCurrentFilter: 0,
    orderItemsCurrentPageNumber: 0,
    orderItemsPageSize: 10,
    orderItemsOrderBy: null,
    orderItemsOrderDirection: null
  }
}

export type OrderItemsModule = Module<OrderItemsState>

const orderItemsModule: OrderItemsModule = {
  namespaced: true,
  state: initialState(),
  initialState: initialState(),
  getters,
  mutations,
  actions
}

export default orderItemsModule



// WEBPACK FOOTER //
// ./src/store/modules/order-items/index.js